import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "../v3/theme.css";
import { featured, projects } from "../v3/data";
import ProjectCard from "../components/v3/ProjectCard";

// Structura as a regular card at the top of the full listing
const structuraCard = {
  num: "P.01",
  live: true,
  title: featured.title,
  desc: featured.desc,
  tech: featured.tech,
  caseStudy: featured.link,
  liveUrl: "https://www.structurafunding.se/en",
};

const allProjects = [structuraCard, ...projects];

const Projects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
    const t = setTimeout(() => lenis.scrollTo(0, { immediate: true }), 250);
    // cards use .stag reveals — trigger them as they scroll into view
    const io = new IntersectionObserver(
      (es) =>
        es.forEach((en) => {
          if (!en.isIntersecting) return;
          const siblings = Array.from(en.target.parentElement.children).filter((c) => c.classList.contains("stag"));
          en.target.style.transitionDelay = (Math.max(siblings.indexOf(en.target), 0) % 3) * 70 + "ms";
          en.target.classList.add("in");
          io.unobserve(en.target);
        }),
      { threshold: 0.1 }
    );
    document.querySelectorAll(".stag:not(.in)").forEach((n) => io.observe(n));
    return () => {
      clearTimeout(t);
      io.disconnect();
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>All Projects — Mohsin Idrees</title>
        <meta
          name="description"
          content="Every project Mohsin Idrees has shipped: AI SaaS platforms, chatbots, real-estate ecosystems, e-commerce marketplaces, and more."
        />
      </Helmet>

      <nav
        style={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          background: "rgba(255,255,255,.88)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid var(--line)",
        }}
      >
        <div className="pagewrap fx jb ac" style={{ height: 72 }}>
          <Link to="/" className="mono fw6" style={{ fontSize: 14.5, color: "var(--ink)" }}>
            ~/mohsin-idrees<span style={{ color: "var(--accent)" }}>_</span>
          </Link>
          <div className="fx ac gap24">
            <Link to="/#work" className="navlink">
              ← back_home
            </Link>
            <Link to="/#contact" className="btn btn-primary" style={{ padding: "10px 20px", fontSize: 13.5 }}>
              Book a call<span className="arr">→</span>
            </Link>
          </div>
        </div>
      </nav>

      <header style={{ padding: "80px 0 0", background: "linear-gradient(160deg, #ffffff 55%, var(--accent-soft) 100%)" }}>
        <div className="pagewrap">
          <div className="shead">
            <div>
              <div className="snum">[ ALL PROJECTS ]</div>
              <h2 className="h2">
                Everything
                <br />
                I've shipped.
              </h2>
            </div>
            <span className="mono hide-mobile" style={{ fontSize: 12, color: "var(--muted)" }}>
              100+ SHIPPED · {String(allProjects.length).padStart(2, "0")} SHOWN
            </span>
          </div>
        </div>
      </header>

      <main className="pagewrap" style={{ paddingBottom: 90 }}>
        <div className="proj-grid">
          {allProjects.map((p) => (
            <ProjectCard p={p} key={p.num} />
          ))}
        </div>
      </main>

      <section
        className="tc"
        style={{
          padding: "90px 0",
          backgroundColor: "var(--ink)",
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,.045) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,.045) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      >
        <div className="pagewrap">
          <div className="mono" style={{ fontSize: 13, color: "#7DD3FC", marginBottom: 18 }}>$ book --call mohsin-idrees</div>
          <h2 className="disp" style={{ fontSize: "clamp(28px, 3.4vw, 44px)", fontWeight: 700, letterSpacing: "-.025em", color: "#fff", margin: "0 0 14px" }}>
            Want yours on this list?
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: "#94A3B8", maxWidth: 480, margin: "0 auto 34px" }}>
            Tell me about your project and I'll come back with a plan.
          </p>
          <Link to="/#contact" className="btn" style={{ background: "var(--accent)", color: "#fff", padding: "16px 34px", fontSize: 15 }}>
            Book a call<span className="arr">→</span>
          </Link>
        </div>
      </section>

      <div className="pagewrap fx jb ac wrap gap12 mono" style={{ padding: "24px 0", color: "var(--muted)", fontSize: 12 }}>
        <div>© {new Date().getFullYear()} MOHSIN IDREES — ALL RIGHTS RESERVED</div>
        <Link to="/" className="mono fs13">
          ← back_home
        </Link>
      </div>
    </>
  );
};

export default Projects;
